import OurProjectVerticalForm from "../../our-project-vertical/Form";
import { useCorporateDesignProjects } from "../../useHook";

const OurProjectCorporateCreate = () => {
  return (
    <OurProjectVerticalForm
      isEditMode={false}
      useProjectsHook={useCorporateDesignProjects}
      listPath="/our-project-corporate-design"
      subtitle="Corporate construction project"
    />
  );
};

export default OurProjectCorporateCreate;
